/**
 * @file: FundSourceType.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 *
 * Mirrors backend `@zhichetech/models` FundSourceType — keep in sync
 * with `packages/models/src/enum/FundSourceType.ts`.
 */

export enum FundSourceType {
  ProductAgent = 'product_agent',
  OrgAccount = 'org_account',
}
